export enum IOperations {
  buyUSD = 'buyUSD',
  sellUSD = 'sellUSD',
  buyStocks = 'buyStocks',
  sellStocks = 'sellStocks',
  buyPortfolio = 'buyPortfolio',
  sellPortfolio = 'sellPortfolio',
  transferStocks = 'transferStocks',
  deposit = 'deposit',
  transferFromStocksToPortfolio = 'transferFromStocksToPortfolio',
  transferFromPortfolioToStocks = 'transferFromPortfolioToStocks',
  transferFromPortfolioToPortfolio = 'transferFromPortfolioToPortfolio',
}

export interface IRestrictedReasons {
  [key: string]: IRestrictedOperations;
}

export interface IRestrictedOperations {
  canBuyUSD: boolean;
  canSellUSD: boolean;
  canBuyStocks: boolean;
  canSellStocks: boolean;
  canBuyPortfolio: boolean;
  canSellPortfolio: boolean;
  canTransferStocks: boolean;
  canDeposit: boolean;
  canTransferFromStocksToPortfolio: boolean;
  canTransferFromPortfolioToStocks: boolean;
  canTransferFromPortfolioToPortfolio: boolean;
}
